import { render } from "./check.svg?vue&type=template&id=0cdd50f2"
const script = {}
script.render = render

export default script